import React from "react";
import OneOffHoldsControl from "../one-off-holds-control/OneOffHoldsControl";
import RecurringHoldsControl from "../recurring-holds-control/RecurringHoldsControl";

const FlexibleHolds = () => {
  return (
    <>
      <div className="cw-mb-12">
        <RecurringHoldsControl />
      </div>
      <div className="cw-mb-12">
        <OneOffHoldsControl />
      </div>
    </>
  );
};

export default FlexibleHolds;
